"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var js_base64_1 = require("js-base64");

var _Token = require('keycloak-connect/middleware/auth-utils/token');

var FakeToken =
/** @class */
function (_super) {
  __extends(FakeToken, _super);

  function FakeToken(clientId) {
    return _super.call(this, '', clientId) || this;
  }

  FakeToken.prototype.isExpired = function () {
    return false;
  };

  FakeToken.prototype.toJSON = function () {
    var _a = this,
        token = _a.token,
        clientId = _a.clientId,
        content = _a.content;

    return {
      token: token,
      clientId: clientId,
      content: content
    };
  };

  FakeToken.create = function (content, clientId) {
    var fakeToken = new FakeToken(clientId);
    fakeToken.content = content;
    return fakeToken;
  };

  FakeToken.fromAuthorization = function (authorization) {
    var jsonText = authorization.substring(FakeToken.prefix.length);

    var _a = JSON.parse(js_base64_1.Base64.decode(jsonText)) || {},
        clientId = _a.clientId,
        json = __rest(_a, ["clientId"]);

    var fakeToken = new FakeToken(clientId);
    Object.assign(fakeToken, json);
    var fake = fakeToken.content.fake;

    for (var _i = 0, _b = FakeToken.fakeMethodNames; _i < _b.length; _i++) {
      var methodName = _b[_i];

      if (fake[methodName]) {
        fakeToken[methodName] = FakeToken.getFakeMethod(fake[methodName]);
      }
    }

    return fakeToken;
  };

  FakeToken.getFakeMethod = function (table) {
    return function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      var curr = table;

      while (typeof curr === 'object') {
        curr = curr[args.shift()];
      }

      return !!curr;
    };
  };

  FakeToken.prefix = 'FakeToken ';
  FakeToken.fakeMethodNames = ['hasRole', 'hasApplicationRole', 'hasRealmRole', 'hasPermission'];
  return FakeToken;
}(_Token);

exports.FakeToken = FakeToken;
var authServerUrl = 'https://auth.devsisters.cloud/auth';
var defaultRealm = 'devsisters';

function getAuthHeaders(config) {
  var token = config.token;

  if (token instanceof FakeToken) {
    return {
      'Authorization': FakeToken.prefix + js_base64_1.Base64.encode(JSON.stringify(token))
    };
  } else {
    return {
      'Authorization': "Bearer " + token.token
    };
  }
}

exports.getAuthHeaders = getAuthHeaders;
var grantManagers = {};

function verify(_a) {
  var headers = _a.headers,
      _b = _a.realm,
      realm = _b === void 0 ? defaultRealm : _b,
      _c = _a.url,
      url = _c === void 0 ? authServerUrl : _c,
      allowFakeToken = _a.allowFakeToken;
  return __awaiter(this, void 0, void 0, function () {
    function getGrantManager(realm) {
      var grantManagerHash = realm;
      if (grantManagers[grantManagerHash]) return grantManagers[grantManagerHash];
      var nodeRequire = eval('require'); // to prevent webpack

      var Config = nodeRequire('keycloak-connect/middleware/auth-utils/config');
      var GrantManager = nodeRequire('keycloak-connect/middleware/auth-utils/grant-manager');
      grantManagers[grantManagerHash] = new GrantManager(new Config({
        authServerUrl: url,
        realm: realm
      }));
      return grantManagers[grantManagerHash];
    }

    var authorization, token;
    return __generator(this, function (_d) {
      switch (_d.label) {
        case 0:
          authorization = headers.authorization;
          if (typeof authorization !== 'string') throw new Error();

          if (allowFakeToken && authorization.startsWith(FakeToken.prefix)) {
            return [2
            /*return*/
            , FakeToken.fromAuthorization(authorization)];
          }

          if (!authorization.startsWith('Bearer ')) throw new Error();
          token = new _Token(authorization.substring(7)); // 인증에 실패하면 안쪽에서 에러를 던져줍니다.

          return [4
          /*yield*/
          , getGrantManager(realm).validateToken(token, 'Bearer')];

        case 1:
          // 인증에 실패하면 안쪽에서 에러를 던져줍니다.
          _d.sent();

          return [2
          /*return*/
          , token];
      }
    });
  });
}

exports.verify = verify;

function login(config) {
  return __awaiter(this, void 0, void 0, function () {
    var Keycloak, _a, checkLoginIframe, keycloakProps, keycloak, t, r, resolve, result;

    var _b;

    var _this = this;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          return [4
          /*yield*/
          , Promise.resolve().then(function () {
            return require('keycloak-js');
          })];

        case 1:
          Keycloak = _c.sent();
          _a = config.checkLoginIframe, checkLoginIframe = _a === void 0 ? false : _a, keycloakProps = __rest(config, ["checkLoginIframe"]);
          keycloak = Keycloak(__assign({
            url: authServerUrl,
            realm: defaultRealm
          }, keycloakProps));

          keycloak.onTokenExpired = function () {
            return __awaiter(_this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    return [4
                    /*yield*/
                    , keycloak.updateToken(-1)];

                  case 1:
                    _a.sent();

                    t = new _Token(keycloak.token);
                    resolve();
                    return [2
                    /*return*/
                    ];
                }
              });
            });
          };

          return [4
          /*yield*/
          , keycloak.init({
            onLoad: 'login-required',
            checkLoginIframe: checkLoginIframe
          })];

        case 2:
          _c.sent();

          t = new _Token(keycloak.token);
          r = [];

          resolve = function resolve() {
            if (!t || !r.length) return;

            for (var _i = 0, r_1 = r; _i < r_1.length; _i++) {
              var resolve_1 = r_1[_i];
              resolve_1({
                done: false,
                value: t
              });
            }

            t = null;
            r = [];
          };

          result = (_b = {}, _b[Symbol.asyncIterator] = function () {
            return result;
          }, _b.next = function () {
            return new Promise(function (_r) {
              r.push(_r);
              resolve();
            });
          }, _b.keycloak = keycloak, _b);
          return [2
          /*return*/
          , result];
      }
    });
  });
}

exports.login = login;